import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormChipGroup, { FormChipGroupProps } from "ui/Form/ChipGroup";

type Props = FormChipGroupProps & UseFieldConfig<Array<string | number>>;

const ChipGroupField: React.FC<Props> = ({ labelProps, fieldGroupProps, inputProps, ...fieldProps }) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormChipGroup
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.error || meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        inputProps={{
                            ...inputProps,
                            name: input.name,
                            value: input.value,
                            onChange: (value) => input.onChange(value),
                        }}
                    />
                );
            }}
        </Field>
    );
};

export default ChipGroupField;
